import React, { useEffect, useState } from "react";
import { Button, Divider, Input, Modal } from "antd";
import { useSelector } from "react-redux";
import { useActionDialogSpeakerName } from "hook/draft/dialog/useActionDialogAdvance";
import { draftDialogSpeakerName } from "store/bailiff/draft/dialog/draft_dialog.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DialogChangeName = () => {
  // -------------------------- VAR -----------------------------
  const { handleCancel, handleSave } = useActionDialogSpeakerName();
  // -------------------------- STATE ---------------------------
  const [text, setText] = useState("");

  // -------------------------- REDUX ---------------------------
  const data = useSelector(draftDialogSpeakerName);
  const open = !!data;
  const origin = data?.origin;
  const id = data?.id;
  const selected = origin?.find((o) => o.id === id) || null;

  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (!selected) return;
    setText(selected?.name || selected?.id || "");
  }, [selected]);
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <div className="flex flex-col gap-3">
        <Divider className="my-4 border-dashed" />
        {renderEnterName()}

        <Divider className="my-4 border-dashed" />
        {renderFooter()}
      </div>
    );
  };

  const renderEnterName = () => {
    return (
      <Input
        placeholder="Nhập tên speaker"
        value={text}
        onChange={(e) => setText(e?.target?.value)}
      />
    );
  };

  const renderFooter = () => {
    return (
      <div className="flex flex-row items-center justify-end gap-2">
        <Button onClick={handleCancel}>Huỷ</Button>
        <Button onClick={() => handleSave({ name: text })} type="primary">
          Lưu
        </Button>
      </div>
    );
  };

  // -------------------------- MAIN ----------------------------
  return (
    <Modal
      onCancel={handleCancel}
      title="Đổi tên Speaker"
      centered
      footer={null}
      open={open}
    >
      {renderBody()}
    </Modal>
  );
};
export default DialogChangeName;
